import { SettingsV2 } from './SettingsV2/SettingsV2';

export type NavMenuItemType = 'url' | 'page' | 'category';

export interface NavMenuItem {
  id: number;
  type: NavMenuItemType;
  url: string;
  name: string;
  parentID: number;
  items: NavMenuItem[];
}

export const navMenuItemFromResponse = (responseData: any): NavMenuItem => ({
  id: responseData.id,
  type: responseData.type,
  url: responseData.url,
  name: responseData.name,
  parentID: responseData.parent_id,
  items: (responseData.items ?? []).map(navMenuItemFromResponse),
});

export interface FrontendSettings {
  settingsV1: Record<string, string>;
  settingsV2?: SettingsV2;
  storeSettings: Record<string, string>;
  availableLocales: string[];
  menu: NavMenuItem[];
  footer1: NavMenuItem[];
  footer2: NavMenuItem[];
}

export const frontendSettingsFromResponse = (
  responseData: any,
): FrontendSettings => {
  let settingsV2: SettingsV2 | undefined;
  try {
    settingsV2 = JSON.parse(responseData.settings?.style_overrides ?? '{}');
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Failed to parse settings_v2', e);
  }

  return {
    settingsV1: responseData.settings,
    settingsV2,
    storeSettings: responseData.store_settings,
    availableLocales: responseData.available_locales ?? [],
    menu: (responseData.menu ?? []).map(navMenuItemFromResponse),
    footer1: (responseData.footer1 ?? []).map(navMenuItemFromResponse),
    footer2: (responseData.footer2 ?? []).map(navMenuItemFromResponse),
  };
};
